import { securedAxiosInstance } from "@/api/axios";
import { toSnakeCase, toCamelCase } from "@estaly/ui/src/utils/data_formatter";

const initialState = {
  isLoading: false,
  index: {},
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    isLoading(state) {
      return state.isLoading;
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
  actions: {
    async fetchIndex({ commit }, params) {
      commit("setLoading", true);
      const response = await securedAxiosInstance.get("/leads", { params: toSnakeCase(params) });
      commit("setLoading", false);
      if (!response?.success) return response;

      const { data } = response;
      commit("setIndex", toCamelCase(data));
    },
  },
};
